import React from 'react';
import { Route, Routes } from 'react-router-dom';
// pages
import Fichajes from './pages/Fichajes';
import Home from './pages/Home';
import PageNotFound from './pages/PageNotFound';
import Perfil from './pages/Perfil';
// pages/admin
import AdminClientes from './pages/admin/Clientes';
import AdminConvenios from './pages/admin/Convenios';
import AdminDepartamentos from './pages/admin/Departamentos';
import AdminExcelGastos from './pages/admin/ExcelGastos';
import AdminExcelHorasExtra from './pages/admin/ExcelHorasExtra';
import AdminLocalidades from './pages/admin/Localidades';
import AdminUsuario from './pages/admin/Usuario';
import AdminUsuarios from './pages/admin/Usuarios';
import Prendas from './pages/admin/Prendas';
// pages/email
import EmailFichaje from './pages/email/Fichaje';
import EmailFirmar from './pages/email/Firmar';
// pages/info
import Calendario from './pages/info/Calendario';
import Docs from './pages/info/Docs';
// pages/supervision
import DescargarHojasDeFichaje from './pages/supervision/DescargarHojasDeFichaje';
import HojasDeFichaje from './pages/supervision/HojasDeFichaje';
import DiasLibres from './pages/supervision/DiasLibres';
import PermisosFichaje from './pages/supervision/PermisosFichaje';
import DiasVacaciones from './pages/supervision/DiasVacaciones';
// pages/validacion
import ValidacionBajas from './pages/validacion/Bajas';
import ValidacionGastos from './pages/validacion/Gastos';
import ValidacionHorasExtras from './pages/validacion/HorasExtras';
import ValidacionPermisos from './pages/validacion/Permisos';
import ValidacionVacaciones from './pages/validacion/Vacaciones';
// pages/vestuario
import SolicitudesVestimenta from './pages/vestuario/Solicitudes';

export default function CustomRoutes() {
    return <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="fichajes" element={<Fichajes key="root" />} />
        <Route exact path="calendario" element={<Calendario key="info" super />} />
        <Route exact path="docs" element={<Docs />} />
        <Route exact path="perfil" element={<Perfil />} />
        <Route exact path="diasLibres" element={<DiasLibres />} />
        <Route exact path="admin/">
            <Route exact path="clientes" element={<AdminClientes />} />
            <Route exact path="convenios" element={<AdminConvenios />} />
            <Route exact path="departamentos" element={<AdminDepartamentos />} />
            <Route exact path="localidades" element={<AdminLocalidades />} />
            <Route exact path="prendas" element={<Prendas />} />
            <Route exact path="usuarios" element={<AdminUsuarios />} />
            <Route exact path="usuarios/nuevo" element={<AdminUsuario new key="nuevo" />} />
            <Route exact path="usuarios/editar/:idUsuario" element={<AdminUsuario key="editar" />} />
            <Route exact path="excelhorasextra" element={<AdminExcelHorasExtra />} />
            <Route exact path="excelgastos" element={<AdminExcelGastos />} />
        </Route>
        <Route exact path="solicitar/">
            <Route exact path="bajas" element={<ValidacionBajas key="solicitar" />} />
            <Route exact path="gastos" element={<ValidacionGastos key="solicitar" />} />
            <Route exact path="horasextra" element={<ValidacionHorasExtras key="solicitar" />} />
            <Route exact path="permisos" element={<ValidacionPermisos key="solicitar" />} />
            <Route exact path="vacaciones" element={<ValidacionVacaciones key="solicitar" />} />
            <Route exact path="vestimenta" element={<SolicitudesVestimenta key="solicitar" />} />
        </Route>
        <Route exact path="validar/">
            <Route exact path="bajas" element={<ValidacionBajas super key="validar" />} />
            <Route exact path="gastos" element={<ValidacionGastos super key="validar" />} />
            <Route exact path="horasextra" element={<ValidacionHorasExtras super key="validar" />} />
            <Route exact path="permisos" element={<ValidacionPermisos super key="validar" />} />
            <Route exact path="vacaciones" element={<ValidacionVacaciones super key="validar" />} />
        </Route>
        <Route exact path="supervisar/">            
            <Route exact path="permisosFichaje" element={<PermisosFichaje super />} />
            <Route exact path="diasLibres" element={<DiasLibres super />} />
            <Route exact path="diasVacaciones" element={<DiasVacaciones super />} />
            <Route exact path="fichajes" element={<Fichajes super key="supervisar" />} />
            <Route exact path="hojasdefichaje" element={<HojasDeFichaje />} />
            <Route exact path="descargarhojas" element={<DescargarHojasDeFichaje />} />
            <Route exact path="fichajes/:idTrabajador/:mes" element={<Fichajes super pdfbtn key="email" />} />
        </Route>
        <Route exact path="vestuario/">
            <Route exact path="solicitudes" element={<SolicitudesVestimenta super key="vestuario" />} />
            <Route exact path="prendas" element={<Prendas />} />
        </Route>
        <Route exact path="email/">
            <Route exact path="fichaje/:idFichaje" element={<EmailFichaje />} />
            <Route exact path="firmar/:idPdf" element={<EmailFirmar />} />
            <Route exact path="fichajes/:idTrabajador/:mes" element={<Fichajes super pdfbtn key="email" />} />
            <Route exact path="fichajes/:idTrabajador/:desde/:hasta" element={<Fichajes super key="email" />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
    </Routes>;
}
